import React from 'react';
import { useNavigate } from 'react-router-dom';

function ProductCard({ product }) {
  const navigate = useNavigate();

  return (
    <div onClick={() => navigate(`/product/${product.id}`)} style={{
      background: '#131313',
      border: '1px solid #242424',
      borderRadius: '12px',
      overflow: 'hidden',
      cursor: 'pointer',
      transition: 'all 0.2s',
      width: '100%'
    }}>
      <div style={{
        background: '#1c1c1c',
        height: '140px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        fontSize: '48px'
      }}>
        {product.image}
        <div style={{
          position: 'absolute',
          top: '8px',
          left: '8px',
          background: '#ff3c00',
          color: 'white',
          fontWeight: 'bold',
          fontSize: '14px',
          padding: '2px 8px',
          borderRadius: '6px'
        }}>
          -{product.discount}%
        </div>
      </div>
      <div style={{ padding: '10px 12px' }}>
        <div style={{ fontSize: '10px', color: '#606060', textTransform: 'uppercase', letterSpacing: '1px', marginBottom: '3px' }}>
          {product.brand}
        </div>
        <div style={{ fontSize: '13px', fontWeight: '500', color: '#f0f0f0', marginBottom: '6px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
          {product.name}
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
          <span style={{ fontSize: '15px', fontWeight: '600', color: '#ffb800' }}>${product.salePrice}</span>
          <span style={{ fontSize: '11px', color: '#606060', textDecoration: 'line-through' }}>${product.originalPrice}</span>
        </div>
      </div>
    </div>
  );
}

export default ProductCard;